import { AgreementHistory } from '@user/components/Agreements/ViewAgreementsDrawer/Table/Row/AgreementHistory'
import { EmailHistory } from '@user/components/Agreements/ViewAgreementsDrawer/Table/Row/EmailHistory'
import { FormHistoryItem } from '@user/store/agreements'
import * as React from 'react'
import { DetailHeader } from '../atoms/DetailHeader.styled'
import { ViewDetailsButton } from '../atoms/ViewDetailsButton'
import type { PopoverOrigin } from '@mui/material/Popover'
import { usePopoverActions } from '@sales-center/common'
import Popover from '@mui/material/Popover'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

type Props = {
  anchorEl: HTMLElement | null
  history: FormHistoryItem[]
  agreementId: number
  onClose: () => void
  open: boolean
}

const popoverSettings: PopoverOrigin = {
  vertical: 'center',
  horizontal: 'left',
}

export function ViewDetailsPopover(props: Props) {
  const { anchorEl, agreementId, history, onClose, open } = props
  const { popoverActionsRef, updatePosition } = usePopoverActions()

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={popoverSettings}
      transformOrigin={popoverSettings}
      action={popoverActionsRef}
      TransitionProps={{
        onEntered: updatePosition,
      }}
    >
      {/*maxHeight added to fix popover position, without that popover with dynamic content doesnt display properly*/}
      <Stack direction="column" paddingX={2} paddingY={1}>
        <ViewDetailsButton onClick={onClose} open={open} />
        <Box>
          <DetailHeader>Agreement History</DetailHeader>
          <AgreementHistory history={history} />
        </Box>
        <Box my={2}>
          <DetailHeader>Email History</DetailHeader>
          <EmailHistory
            agreementId={agreementId}
            updatePosition={updatePosition}
          />
        </Box>
      </Stack>
    </Popover>
  )
}
